<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  methods: {
    changeThemeColor(color) {
      document.body.style.setProperty('--themeColor', color);
    }
  },
  created() {
    // 在页面加载时读取sessionStorage
    if (sessionStorage.getItem('store')) {
      this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem('store'))))
    }
    // 在页面刷新时将store保存到sessionStorage里
    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem('store', JSON.stringify(this.$store.state))
    })

    this.changeThemeColor(this.theme_color)
  },
  computed: {
    theme_color() {
      let vv = this.$store.getters.theme_color
      console.log('vv',vv)
      return vv.theme_color;
    },
  },

}
</script>


<style lang="less">
@import "./assets/css/common.css";
@import "./assets/css/bigscreen.css";
/*1rem=10px*/
@import "./assets/css/comm_wap.css";

/* 解决浏览器升级后不能自动竖起来的 */
.ivu-input, .ivu-select-input {
  display: table-column !important;
}

@font-face {
  font-family: "MongolQaganTig";
  src: url("./assets/fonts/MongolQaganTig.ttf");
}

.MongolQaganTig {
  font-family: "MongolQaganTig" !important;
}


@font-face {
  font-family: "OrhonChaganTig";
  src: url("./assets/fonts/OrhonChaganTig.ttf") format("truetype");
}

@font-face {
  font-family: "OrhonHawangTig";
  src: url("./assets/fonts/OrhonHawangTig.ttf") format("truetype");
}

@font-face {
  font-family: "OrhonChaganTig-H";
  src: url("./assets/fonts/OrhonChaganTig-H.ttf") format("truetype");
}

@font-face {
  font-family: "OrhonChaganTig-RTL";
  src: url("./assets/fonts/OrhonChaganTig-RTL.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "OrhonChaganTig-V";
  src: url("./assets/fonts/OrhonChaganTig-V.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "OrhonGarchagTig";
  src: url("./assets/fonts/OrhonGarchagTig.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "OrhonGarchagTig-H";
  src: url("./assets/fonts/OrhonGarchagTig-H.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "OrhonGarchagTig-RTL";
  src: url("./assets/fonts/OrhonGarchagTig-RTL.ttf") format("truetype");
}

@font-face {
  font-family: "OrhonGarchagTig-V";
  src: url("./assets/fonts/OrhonGarchagTig-V.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
}


/* 元素竖排 */
.aqt_su {
  writing-mode: vertical-lr !important;
}

/* 元素取消竖排 */
.aqt_no_su {
  writing-mode: horizontal-tb;
}

/* 蒙语字竖起来的属性 */
.aqt_lang_mn {
  writing-mode: vertical-lr;
  text-orientation: sideways-right;
  text-orientation: sideways !important;
  -o-text-orientation: sideways !important;
  -ms-text-orientation: sideways !important;
  -moz-text-orientation: sideways !important;
  -webkit-text-orientation: sideways !important;
  -webkit-text-orientation: sideways-right !important;
}

/* 上下左右剧中 */
.aqt_ce_ve {
  display: flex;
  width: 100%;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-pack: center;
  display: -ms-flexbox;
  justify-content: center;
}

* {
  margin: 0;
  padding: 0;
}


#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
}


//  提示框
.ivu-message {
  display: flex !important;
  justify-content: flex-end !important;

  .ivu-message-notice {
    width: 54px !important;

    .ivu-message-notice-content {
      padding: 16px 8px !important;

      .ivu-message-custom-content {
        writing-mode: vertical-lr !important;
        text-orientation: sideways-right;
        text-orientation: sideways !important;
        -o-text-orientation: sideways !important;
        -ms-text-orientation: sideways !important;
        -moz-text-orientation: sideways !important;
        -webkit-text-orientation: sideways !important;
        -webkit-text-orientation: sideways-right !important;
        font-family: "MongolQaganTig" !important;
      }
    }
  }
}
img{
  -webkit-user-drag: none; /* Safari */
  -khtml-user-drag: none; /* Konqueror */
  -moz-user-drag: none; /* Firefox */
  -o-user-drag: none; /* Opera */
  user-drag: none; /* 其他浏览器 */
}
</style>
